import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { titleize, humanize } from 'underscore.string';
import { cn } from 'utils/ui/classes';
function getColor(status) {
    const key = status.toLowerCase().replace(/\s+/g, '_');
    switch (key) {
        case 'complete':
            return 'bg-green-100 text-green-800 border-green-300';
        case 'en_route':
        case 'in_progress':
        case 'arrived':
        case 'accepted':
        case 'exposed':
        case 'needs_appt':
            return 'bg-green text-white border-green';
        case 'scheduled':
        case 'booked':
            return 'bg-indigo-100 text-indigo-800 border-indigo-300';
        case 'booking':
            return 'bg-yellow-100 text-yellow-800 border-yellow-300';
        case 'canceled':
        case 'job_canceled':
            return 'bg-red-100 text-red-800 border-red-300';
        default:
            return 'bg-gray-100 text-gray-800 border-gray-300';
    }
}
export default function ShipmentStatusBadge({ className = '', status, label, }) {
    if (!status)
        return null;
    return (React.createElement(Badge, { variant: "outline", className: cn('whitespace-nowrap self-start shrink-0 grow-0', getColor(status), className) }, label !== null && label !== void 0 ? label : titleize(humanize(status))));
}
